import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_sr-only" }
const _hoisted_2 = { class: "gfu-footer-section" }
const _hoisted_3 = { class: "gfu-layout-wrapper" }
const _hoisted_4 = { class: "gfu-grid gfu-grid--gutter" }
const _hoisted_5 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m _flexcol" }
const _hoisted_6 = { class: "_mb-2" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "_mb-4" }
const _hoisted_9 = { class: "_flex _ai-c _mb-3" }
const _hoisted_10 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--m gfu-footer-communication" }
const _hoisted_11 = { class: "_sr-only" }
const _hoisted_12 = { class: "gfu-hd gfu-hd--light gfu-hd--h4 _ttu _mb-2" }
const _hoisted_13 = ["target", "href", "data-qa"]
const _hoisted_14 = { class: "gfu-layout-wrapper _py-3" }
const _hoisted_15 = { class: "_flex _fd-c _fd-r--l _gap-3" }
const _hoisted_16 = { class: "gfu-1of1 gfu-2of3--m gfu-3of4--l gfu-footer-info-links" }
const _hoisted_17 = ["href", "onClick", "data-qa"]
const _hoisted_18 = { class: "gfu-1of1 gfu-1of3--m gfu-1of4--l" }
const _hoisted_19 = { class: "gfu-footer-payment" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_external_link = _resolveComponent("external-link")
  const _component_footer_selectors = _resolveComponent("footer-selectors")
  const _component_re_captcha_policy = _resolveComponent("re-captcha-policy")

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass(['gfu-footer', $options.visibilityClass])
  }, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.Resources.Common.FooterTitle), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", { href: $options.homeUrl }, [
                _createVNode(_component_base_image, {
                  src: "/content/images/static/inverse/logo/site-logo.svg",
                  alt: $options.platformName
                }, null, 8 /* PROPS */, ["alt"])
              ], 8 /* PROPS */, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.Resources.Common.MainTagline), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.socials, (social) => {
                return (_openBlock(), _createBlock(_component_external_link, {
                  key: social.name,
                  class: "_mr-2 gfu-link gfu-link--nofx",
                  href: social.url,
                  target: "_blank",
                  rel: "nofollow noopener noreferrer",
                  "aria-label": social.name,
                  "data-qa": `layout-footer-link:${social.name}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: social.icon,
                      "icon-namespace": "brands",
                      size: "lg"
                    }, null, 8 /* PROPS */, ["name"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href", "aria-label", "data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createVNode(_component_footer_selectors)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.Resources.Common.FooterNavigationSectionTitle), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.platformLinks, (section) => {
              return (_openBlock(), _createElementBlock("div", {
                key: section.sectionName,
                class: _normalizeClass(section.classList)
              }, [
                _createElementVNode("h4", _hoisted_12, _toDisplayString(section.sectionName), 1 /* TEXT */),
                _createElementVNode("nav", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.links, (link) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: link.name,
                      class: "_mb-1",
                      target: link.target,
                      href: link.url,
                      "data-qa": `layout-footer-link:${link.name}`
                    }, _toDisplayString(link.name), 9 /* TEXT, PROPS */, _hoisted_13))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("nav", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.servicePolicies, (link) => {
            return (_openBlock(), _createElementBlock("a", {
              key: link.name,
              href: link.url,
              class: "gfu-link gfu-link--light",
              onClick: link.onAction,
              "data-qa": `layout-footer-link:${link.key}`
            }, _toDisplayString(link.name), 9 /* TEXT, PROPS */, _hoisted_17))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardBrands, (card) => {
              return (_openBlock(), _createBlock(_component_base_image, {
                key: card.code,
                src: card.imgUrl,
                alt: card.name,
                width: "30",
                height: "18"
              }, null, 8 /* PROPS */, ["src", "alt"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      ($options.isCaptchaEnabled)
        ? (_openBlock(), _createBlock(_component_re_captcha_policy, {
            key: 0,
            class: "_mt-3"
          }))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}